import axios from 'axios'

export const getAllCity = (params) => {
  let remoteUrl = 'cities'

  return axios.get(remoteUrl, {params: params})
}

export const getCity = (configs) => {
  let remoteUrl = 'cities/' + configs.id

  return axios.get(remoteUrl, {params: configs.params})
}

export const addCity = (data) => {
  let remoteUrl = 'cities'
  return axios.post(remoteUrl, data)
}

export const editCity = (id, data) => {
  let remoteUrl = 'cities/' + id
  return axios.put(remoteUrl, data)
}

export const deleteCity = (id) => {
  let remoteUrl = 'cities/' + id
  return axios.delete(remoteUrl)
}

export const restoreCity = (id) => {
  return axios.post('cities/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/city.js